export default {
  CLIENT_NOT_FOUND: 'CLIENT_NOT_FOUND',
  TOKEN_NOT_FOUND: 'TOKEN_NOT_FOUND',
  NO_RECOVERY_FOUND: 'NO_RECOVERY_FOUND',
  NEW_PASSWORD_IS_NULL: 'NEW_PASSWORD_IS_NULL',
  PASSWORD_RECOVERY_BLOCKED: 'PASSWORD_RECOVERY_BLOCKED'
};